import LocalApa from './LocalApa';

class LocalTranslations extends LocalApa {}

export default LocalTranslations;



// WEBPACK FOOTER //
// ./src/requests/apa/local/LocalTranslations.js